// DivisionOrgSalesAdminApi.js
import sharedDivisionOrgSalesWebApi from '@shared-library/api/services/divisionOrgSalesWebApi.js'

export default function(apiClient) {
  // 使用共享库的DivisionOrgSalesApi，并可以扩展或覆盖
  const sharedApi = sharedDivisionOrgSalesWebApi(apiClient);
  
  return {
    // 继承共享库的所有方法
    ...sharedApi,
    
    // 如果需要添加项目特定的方法，可以在这里添加
    // 例如：
    // adminSpecificMethod() {
    //   return apiClient.get('/admin/division-org-sales/custom-endpoint');
    // }
  }
}